import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'

import { propOr } from 'ramda'
import ReactPlayer from 'react-player/lazy'
import { A11y, Autoplay, Pagination, Scrollbar } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'

import useProgram from '../stores/use-program'

const programSelector = propOr({}, 'program')

const Slider = () => {
  const program = useProgram(programSelector)
  const { gallery } = program
  return (
    <div className='cover-slider my-5'>
      <Swiper
        modules={[Pagination, A11y, Scrollbar, Autoplay]}
        slidesPerView={1}
        pagination={{ clickable: true }}
        scrollbar={{ draggable: true }}
        autoplay={{
          delay: 3000,
          disableOnInteraction: true,
          pauseOnMouseEnter: true,
        }}
      >
        {gallery.map((el) => (
          <SwiperSlide key={el.url}>
            {el.type === 'IMAGE' ? (
              <img
                src={el.url}
                alt='Gallery Item'
                className='h-full w-full object-contain'
              />
            ) : (
              <ReactPlayer url={el.url} height='100%' width='100%' controls />
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default Slider
